import React from 'react'
import {Trans} from 'react-i18next'
import Link from 'components/Link'
import {SubtitleView} from './SubtitleStyles'
import {getAboutLink} from 'utils/languageUtils'

const SubtitleWithMigrationText = ({styles}) => (
  <SubtitleView styles={styles}>
    <Trans i18nKey="migration.message">
      Your user account will now be integrated with
      <Link fontSize="inherit" to={getAboutLink()} target="_blank" external>
        OneLog
      </Link>
      , the central Swiss media login.
    </Trans>
  </SubtitleView>
)

export default SubtitleWithMigrationText
